import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { OperationCardListing, OperationCardAddEdit } from './Pages/';

export const OperationCardRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={OperationCardListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={OperationCardAddEdit} />
    </Fragment>
)